export const ACTIONS = {
  OPEN_CHAT_WINDOW: 'OPEN_CHAT_WINDOW',
  NEW_MESSAGE_COUNT: 'NEW_MESSAGE_COUNT',
};

export const openChatWindow = event => dispatch => {
  dispatch({
    type: ACTIONS.OPEN_CHAT_WINDOW,
    payload: {
      event,
    },
  });
};

export const newMessageCount = messageCount => dispatch => {
  dispatch({
    type: ACTIONS.NEW_MESSAGE_COUNT,
    payload: {
      messageCount,
    },
  });
};
